import { useEffect, useState } from "react";
import { layoutTicketInscription, ticketFontFamily, ticketSessionLettering, ticketSessionLabel, ticketInk, ticketPlaneMatrix } from "@/lib/ticket";
import type { TicketData } from "@/types/journey";

export function TicketInscription({ action, profile, ticket }: { action: string; profile: "mobile" | "desktop"; ticket?: TicketData }) {
  const stamp = ticketSessionLettering[profile];
  const [layout, setLayout] = useState<ReturnType<typeof layoutTicketInscription> | null>(null);
  useEffect(() => {
    let active = true;
    const measure = () => {
      const context = document.createElement("canvas").getContext("2d");
      if (active && context) setLayout(layoutTicketInscription(context, action, profile));
    };
    measure();
    void document.fonts.ready.then(measure);
    return () => { active = false; };
  }, [action, profile]);
  return layout ? <svg className="v2-ticket-inscription" viewBox={`0 0 ${layout.width} ${layout.height}`} preserveAspectRatio="xMidYMid slice" role="img" aria-label={`我的答案：${action}${ticket ? `，${ticketSessionLabel(ticket)}` : ""}`}>
    <g transform={`matrix(${ticketPlaneMatrix(profile).join(" ")})`} fill={ticketInk.color} opacity={ticketInk.opacity} fontFamily={ticketFontFamily} fontWeight={ticketInk.weight} fontSize={layout.fontSize}>
      {layout.lines.map((line, index) => <text key={index} x="0" y={layout.offsetY + layout.fontSize + index * layout.lineHeight}>{line}</text>)}
      {ticket ? <text x="0" y={stamp.offsetY} fontSize={stamp.fontSize}>{ticketSessionLabel(ticket)}</text> : null}
    </g>
  </svg> : <span className="v2-sr-only">{action}</span>;
}
